
//     Init Variant Selects
//
//     Data attributes accept:
//     - data-disable-url-update: {bool} Disable url update on variant change (optional)
//
//     Usage:
//     <variant-selects data-section="{{ product.id }}" data-url="{{ product.url }}" data-disable-url-update></variant-selects>

import VariantRadios from './variant-radios';

class VariantSelect extends VariantRadios {
    constructor() {
      super();
    }

    updateOptions() {
      this.selectedOption = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
}

customElements.define('variant-select', VariantSelect);

class VariantSelectCart extends VariantSelect {
  constructor() {
    super();
  }

  renderProductInfo() {
    const productCard = this.closest('.js-cart-product-card');
    const productCardPrice = productCard?.querySelector('.js-cart-product-card-price');

    if (productCardPrice) {
      productCardPrice.innerHTML = Shopify.formatMoney(this.currentVariant.price).replace(',00', '');
    }
  }

  renderProductDescription() {
    return;
  }
}

if (customElements.get('variant-select-cart-product') === undefined) {
  customElements.define('variant-select-cart-product', VariantSelectCart);
}
